import React from "react";
import {Modal, Button} from "react-bootstrap";

export default function ({show, onHide, putPaidTicket}) {
    const handleSubmit = () => {
        putPaidTicket()
    }
    return (
        <>
            <Modal centered show={show} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title id="payment"></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>Bileti ödəməyə əminsiniz?</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onHide(false)} variant="secondary">Bağla</Button>
                    <Button onClick={handleSubmit} variant="danger">Mərc et</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}